import React, { FC, PropsWithChildren } from 'react';
import { SVGTooltipProps } from '@utils';
import { Tooltip } from '../tooltip/Tooltip';
import { SvgWrapperTooltipSupport } from '.';
import { SvgWrapper } from './SvgWrapper';

export const SvgWithTooltip: FC<PropsWithChildren<SVGTooltipProps>> = ({ 
  onClick, divClassName, tooltip, children 
}) => (
  tooltip ? (
    <Tooltip
      title={<p>{tooltip}</p>}
      arrow
      placement='top-start'
    >
      <SvgWrapperTooltipSupport
        onClick={onClick}
        divClassName={divClassName}
      >
        {children}
      </SvgWrapperTooltipSupport>
    </Tooltip>
  )
  : (
    <SvgWrapper 
      onClick={onClick}
      divClassName={divClassName}
    >
      {children}
    </SvgWrapper>
  )
);
